/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  CheckUserEmailExistsOptions,
  CheckUserEmailExistsStatus200,
  CheckUserEmailExistsStatus400,
  CheckUserEmailExistsStatus500,
} from '../types/CheckUserEmailExists'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { checkUserEmailExists } from '../clients/checkUserEmailExists'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const checkUserEmailExistsQueryKey = ({
  query,
}: Omit<CheckUserEmailExistsOptions, 'headers'>) =>
  [{ url: '/v1/user/exists' }, ...(query ? [query] : [])] as const

type CheckUserEmailExistsQueryKey = ReturnType<typeof checkUserEmailExistsQueryKey>

export function checkUserEmailExistsQueryOptions(
  { query, headers }: CheckUserEmailExistsOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = checkUserEmailExistsQueryKey({ query })
  return queryOptions<
    CheckUserEmailExistsStatus200,
    ResponseErrorConfig<CheckUserEmailExistsStatus400 | CheckUserEmailExistsStatus500>,
    CheckUserEmailExistsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return checkUserEmailExists({
        ...config,
        query,
        headers,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Checks email existence within a tenant scope. If `tenant-id` (preferred) or legacy `tenant_id` header is provided, lookup is tenant-specific. If both headers are omitted, the server falls back to the default DORA tenant.
 * @summary Check whether a user email exists
 * {@link /v1/user/exists}
 */
export function useCheckUserEmailExists<
  TData = CheckUserEmailExistsStatus200,
  TQueryData = CheckUserEmailExistsStatus200,
  TQueryKey extends QueryKey = CheckUserEmailExistsQueryKey,
>(
  {
    query,
    headers,
  }: {
    query: CheckUserEmailExistsOptions['query'] | (() => CheckUserEmailExistsOptions['query'])
    headers?:
      | CheckUserEmailExistsOptions['headers']
      | (() => CheckUserEmailExistsOptions['headers'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        CheckUserEmailExistsStatus200,
        ResponseErrorConfig<CheckUserEmailExistsStatus400 | CheckUserEmailExistsStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = {
    query: typeof query === 'function' ? query() : query,
    headers: typeof headers === 'function' ? headers() : headers,
  }
  const queryKey = resolvedOptions?.queryKey ?? checkUserEmailExistsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...checkUserEmailExistsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<CheckUserEmailExistsStatus400 | CheckUserEmailExistsStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
